import { ABLLSParsedResult, AFLSParsedResult } from "@api/assessments/assessment-schema-types";
import type { AssessmentLayoutConfig } from "@components/AssessmentFormRenderer/types/layoutTypes";

export const ABLLS_LAYOUT: AssessmentLayoutConfig = {
  parsedResultSchema: ABLLSParsedResult,
  sections: [
    {
      type: "skill_checklist",
      label: "Skill Areas",
      dataKey: "Skill Areas",
      sessionDataKey: "Sessions",
      skillArea: {
        nameKey: "Name",
        maxScoreKey: "Max Score",
        itemsKey: "Items",
      },
      item: {
        codeKey: "Code",
        nameKey: "Name",
        scoreMin: 0,
      },
    },
  ],
};

export const AFLS_LAYOUT: AssessmentLayoutConfig = {
  parsedResultSchema: AFLSParsedResult,
  sections: [
    {
      type: "skill_checklist",
      label: "Skill Areas",
      dataKey: "Skill Areas",
      sessionDataKey: "Sessions",
      skillArea: {
        nameKey: "Name",
        maxScoreKey: "Max Score",
        itemsKey: "Items",
      },
      item: {
        codeKey: "Code",
        nameKey: "Name",
        scoreMin: 0,
      },
    },
  ],
};
